import { type FunctionComponent, useMemo } from 'react';
import { Helmet } from 'react-helmet';

type TAppHelmetProps = {
  title?: string;
  description?: string;
  keywords?: string;
  type?: string;
  name?: string;
};

const appName = 'Việt An nội bộ';

export const AppHelmet: FunctionComponent<TAppHelmetProps> = props => {
  const { title, description = '', keywords } = props;
  const SEOKeywords = useMemo(() => keywords || appName, [keywords]);

  const pageTitle = title ? `${title} | ${appName}` : appName;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="robots" content="index, follow" />
      <meta key="googlebot" name="googlebot" content="index,follow" />
      <meta name="google" content="notranslate" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="keywords" content={SEOKeywords} />
    </Helmet>
  );
};
